import * as React from "react";
import * as Scrivito from "scrivito";
import { FooterLinkedImage } from "components";
import s from "./ImageFooterWidget.module.scss";

interface ImageFooterWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent(
  "ImageFooterWidget",
  ({ widget }: ImageFooterWidgetProps) => {
    if (!widget) return null;
    return (
      <FooterLinkedImage widget={widget} className={s.footerImageWrapper} />
    );
  },
);
